import styles from "./ListeAdgange.module.scss";
import { IOrganisationState } from "./OpretListe";
import Close from "@/components/common/icons/Close";
import MultipleSelectCombobox from "@/components/common/MultipleSelectCombobox/MultipleSelectCombobox";
import { color } from "@/styles/theme";

interface ListeAdgangeProps {
  listeOrganisationerState: IOrganisationState;
  setListeOrganisationerState: Function;
  organisationerState: IOrganisationState;
}

export default function ListeAdgange(props: ListeAdgangeProps) {
  const {
    listeOrganisationerState,
    organisationerState,
    setListeOrganisationerState,
  } = props;

  const itemIsSelected = (item) =>
    listeOrganisationerState.data.some((i) => i.id === item.id);
  return (
    <div className={styles.container}>
      <h5>Adgang til listen</h5>
      {listeOrganisationerState.state === "IDLE" &&
        organisationerState.state === "IDLE" && (
          <>
            <div className="d-flex gap-2 mt-2">
              <button
                type="button"
                onClick={() => {
                  setListeOrganisationerState({
                    ...listeOrganisationerState,
                    data: organisationerState.data,
                  });
                }}
                className={styles.kommune_btn}
              >
                Vælg alle
              </button>
              <button
                type="button"
                onClick={() => {
                  setListeOrganisationerState({
                    ...listeOrganisationerState,
                    data: [],
                  });
                }}
                className={styles.kommune_btn}
              >
                Fjern alle
              </button>
            </div>
            <MultipleSelectCombobox
              inputClassName={"mt-3"}
              inputStyle={{ marginBottom: 0, padding: "1rem", height: "4rem" }}
              menuStyle={{ position: "relative", padding: 0, top: 0 }}
              listItemStyle={{ height: "3rem" }}
              selectedItems={listeOrganisationerState.data}
              addSelectedItem={(item) => {
                setListeOrganisationerState({
                  ...listeOrganisationerState,
                  data: [...listeOrganisationerState.data, item],
                });
              }}
              removeSelectedItem={(item) => {
                setListeOrganisationerState({
                  ...listeOrganisationerState,
                  data: listeOrganisationerState.data.filter(
                    (lo) => lo.id !== item.id
                  ),
                });
              }}
              getFilteredItems={(_selectedItems, inputValue) => {
                const lowerCasedInputValue = inputValue.toLowerCase();
                return organisationerState.data
                  .sort((a, b) => {
                    if (itemIsSelected(a) && !itemIsSelected(b)) return -1;
                    if (!itemIsSelected(a) && itemIsSelected(b)) return 1;
                    if (a.navn.includes("Skat") && !b.navn.includes("Skat"))
                      return -1;
                    if (!a.navn.includes("Skat") && b.navn.includes("Skat"))
                      return 1;
                    return a.navn.localeCompare(b.navn, "da-DK");
                  })
                  .filter((o) => {
                    return (
                      o.navn.toLowerCase().includes(lowerCasedInputValue) ||
                      (o.kommunenr &&
                        o.kommunenr.toString().includes(lowerCasedInputValue))
                    );
                  });
              }}
              itemIsSelected={itemIsSelected}
              itemToString={(item) => item?.navn ?? ""}
              itemKey="id"
            />
            {listeOrganisationerState.data.length === 0 && (
              <ul className={styles.list}>
                <li>Ingen organisationer har adgang til listen</li>
              </ul>
            )}
          </>
        )}
      {listeOrganisationerState.data.length > 0 && (
        <ul
          style={{
            display: "flex",
            gap: "0.5rem",
            flexWrap: "wrap",
            width: "100%",
          }}
        >
          {listeOrganisationerState.data.map((org) => {
            return (
              <li
                key={org.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: color.green[300],
                  padding: "0.5rem 1rem",
                  flexWrap: "nowrap",
                }}
                className="rounded"
              >
                <span style={{ fontWeight: 600 }}>{org.navn}</span>
                <button
                  type="button"
                  onClick={() => {
                    setListeOrganisationerState({
                      ...listeOrganisationerState,
                      data: listeOrganisationerState.data.filter(
                        (lo) => lo.id !== org.id
                      ),
                    });
                  }}
                  style={{
                    backgroundColor: color.green[900],
                    marginLeft: "1rem",
                    borderRadius: "100%",
                    padding: 5,
                    display: "flex",
                  }}
                >
                  <Close height={10} primaryColor={color.green[300]} />
                </button>
              </li>
            );
          })}
        </ul>
      )}
      {listeOrganisationerState.state === "LOADING" && (
        <p>Laster adgange ...</p>
      )}
      {listeOrganisationerState.state === "ERROR" && (
        <p>Henting af adgange fejlede.</p>
      )}
    </div>
  );
}
